import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="revenue-calculator"
// Calculates lost revenue from missed website visitors
export default class extends Controller {
  static targets = ["visitors", "visitorsDisplay", "ticket", "ticketDisplay", "result", "jobsLost", "jobsLabel"]

  // Close rates (as decimals) - using midpoint of ranges shown
  static values = {
    formCloseRate: { type: Number, default: 0.015 },   // 1-2% for contact forms (midpoint: 1.5%)
    onlineCloseRate: { type: Number, default: 0.05 }   // 4-6% for instant booking (midpoint: 5%)
  }

  connect() {
    this.calculate()
  }

  calculate() {
    const visitors = parseInt(this.visitorsTarget.value) || 150
    const ticket = parseInt(this.ticketTarget.value) || 250

    // Formula: visitors * (online_rate - form_rate) * ticket
    const closeRateDiff = this.onlineCloseRateValue - this.formCloseRateValue
    const lostRevenue = Math.round(visitors * closeRateDiff * ticket)
    const jobsLost = Math.round(visitors * closeRateDiff)

    // Update displays
    this.visitorsDisplayTarget.textContent = visitors.toLocaleString()
    this.ticketDisplayTarget.textContent = ticket.toLocaleString()
    this.resultTarget.textContent = lostRevenue.toLocaleString()
    this.jobsLostTarget.textContent = jobsLost.toLocaleString()
    this.jobsLabelTarget.textContent = jobsLost === 1 ? "pool job" : "pool jobs"
  }
}
